
import DOMPurify from 'dompurify';

/**
 * Sanitizes and renders HTML content safely
 */
export const renderSafeHTML = (html: string): string => {
  // Configure DOMPurify to allow links and basic formatting
  const sanitizeConfig = {
    ALLOWED_TAGS: [
      'b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 
      'code', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'span'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id', 'style']
  };
  
  return DOMPurify.sanitize(html, sanitizeConfig);
};

/**
 * Formats message text with Markdown-like syntax
 */
export const formatMessage = (text: string): string => {
  if (!text) return '';
  
  // Convert Markdown-style links if not already HTML
  if (!text.includes('<a href=')) {
    // Match Markdown links: [text](url)
    text = text.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g, 
      '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-goldcore underline">$1</a>'
    );
  
    // Match plain URLs
    text = text.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-goldcore underline">$1</a>'
    );
  }

  // Convert other Markdown syntax
  text = text
    // Bold
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    // Italic
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    // Line breaks
    .replace(/\n/g, '<br />');
  
  return text;
};
